import { useEffect, useState } from "react";
import "./Ugc.css";
import DynamicBanner from "../../Pages/include/DynamicBanner";
import DynamicPdfCard from "../../Pages/include/DynamicPdfCard";
import api from "../../../api"; 

const Ugc = () => {
  const [banner, setBanner] = useState({
    title: "",
    desktop: [],
    mobile: []
  });

  const [cardData, setCardData] = useState({
    heading: "",
    images: [],
    documents: []
  });

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUgcData = async () => {
      try {
        const res = await api.get("/api/sitepages/academic/ugc");
        const data = res.data.data || {};

        // ---------------- BANNER ----------------
        setBanner({
          title: data.banner_title || "",
          desktop: (data.desktop_images || []).map(img =>
            img ? `/${img.replace(/^\//, "")}` : null
          ).filter(Boolean),
          mobile: (data.mobile_images || []).map(img =>
            img ? `/${img.replace(/^\//, "")}` : null
          ).filter(Boolean)
        });

        // ---------------- PDF DOCUMENTS ----------------
        const allDocs = [];

        (data.ugc_items || []).forEach(item => {
          (item.files || []).forEach(file => {
            allDocs.push({
              title: item.heading, // <-- show heading for each file
              type: "pdf",
              pdfLink: `/${file.replace(/^\//, "")}`
            });
          });
        });

        setCardData({
          heading: data.banner_title || "UGC Documents",
          images: [],
          documents: allDocs
        });

      } catch (err) {
        console.error("Error loading UGC data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchUgcData();
  }, []);

  if (loading) {
    return <div className="container py-5 text-center">Loading...</div>;
  }

  return (
    <section className="ugc-section">

      <DynamicBanner
        title={banner.title}
        bgImage={banner.desktop}
        bgImageMobile={banner.mobile}
      />

      <DynamicPdfCard
        heading={cardData.heading}
        images={cardData.images}
        documents={cardData.documents}
      />

    </section>
  );
};

export default Ugc;
